import React, { useState, useEffect } from 'react';
import '../styles/About.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const About = () => {
  const [sliderIndex, setSliderIndex] = useState(0);
  
  const categories = [
    { icon: "fa-motorcycle", label: "2 Wheeler", color: "#e74c3c" },
    { icon: "fa-car-side", label: "3 Wheeler", color: "#f39c12" },
    { icon: "fa-car", label: "4 Wheeler", color: "#2ecc71" },
    { icon: "fa-truck", label: "Commercial Vehicle", color: "#9b59b6" },
    { icon: "fa-tractor", label: "Tractor", color: "#d35400" },
    { icon: "fa-tools", label: "General", color: "#3498db" },
    { icon: "fa-store", label: "Dealer Market", color: "#1abc9c" },
    { icon: "fa-industry", label: "General Machinery", color: "#e67e22" },
    { icon: "fa-hammer", label: "Crusher Segment", color: "#95a5a6" },
    { icon: "fa-gem", label: "Granite Industries", color: "#8e44ad" },
    { icon: "fa-cogs", label: "CNC Machine", color: "#34495e" },
    { icon: "fa-recycle", label: "Plastic Injection Molding", color: "#27ae60" },
    { icon: "fa-tshirt", label: "Textile Industry", color: "#e84393" },
    { icon: "fa-building", label: "Steel Segment", color: "#e74c3c" },
    { icon: "fa-city", label: "Cement Segment", color: "#3498db" }
  ];

  const testimonials = [
    { icon: "fa-shopping-bag", label: "Retail Outlet - 220", color: "#2ecc71", className: "retail-outlet" },
    { icon: "fa-wrench", label: "Garage - 15", color: "#d35400", className: "garage" },
    { icon: "fa-store-alt", label: "Showroom - 10", color: "#f1c40f", className: "showroom" },
    { icon: "fa-users", label: "Employee - 2 to 10", color: "#1abc9c", className: "employee" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setSliderIndex(prevIndex => (prevIndex + 1) % categories.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [categories.length]);

  return (
    <div className="about-container">
      <h2>Whom We Work With</h2>
      <div className="categories-grid">
        {categories.map((category, index) => (
          <div key={index} className="category-card" style={{ backgroundColor: category.color }}>
            <i className={`fas ${category.icon} category-icon`}></i>
            <h3>{category.label}</h3>
          </div>
        ))}
      </div>

      {/* City Enterprises Section */}
      <div className="city-enterprises-info">
        <h2>City Enterprises - Your Trusted Partner for Automotive and Industrial Solutions</h2>
        <p>
          Authorized Distributor of Balmerol and Chemoleum<br />
          Established in 2008, City Enterprises has been a reliable supplier of premium automotive parts and lubricants across Krishnagiri and Dharmapuri districts, India. As authorized distributors for Balmerol and Chemoleum, we ensure your engines and industrial machinery receive the highest quality protection and performance.
        </p>
        <ul>
          <li>Automotive Lubricants: High-performance oils and additives tailored for all vehicle types.</li>
          <li>Industrial Solutions: Specialized lubricants and tools to optimize productivity and efficiency.</li>
          <li>Automobile Dealer Support: A wide range of products catering to diverse vehicle needs.</li>
        </ul>
      </div>

      {/* Our Dealers Section */}
      <div className="dealer-section">
        <h3>Our Dealers</h3>
        <div className="dealer-grid">
          <img src={require("../images/Dealer.png")} alt="Dealer 1" className="dealer-img" />
          <img src={require("../images/Dealer1.png")} alt="Dealer 2" className="dealer-img" />
          <img src={require("../images/Dealer3.jpg")} alt="Dealer 3" className="dealer-img" />
          <img src={require("../images/Dealer4.jpg")} alt="Dealer 4" className="dealer-img" />
          <img src={require("../images/Dealer5.jpg")} alt="Dealer 5" className="dealer-img" />
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="testimonials-section">
        <h3>Testimonials</h3>
        <div className="testimonials-grid">
          {testimonials.map((item, index) => (
            <div key={index} className={`testimonial-card ${item.className}`}>
              <i className={`category-icon fas ${item.icon}`} style={{ color: item.color }}></i>
              <h3>{item.label}</h3>
            </div>
          ))}
        </div>
      </div>

      {/* Our Collaboration Section */}
      <div className="collaboration-section">
        <h3>Our Collaboration</h3>
        <div className="collaboration-grid">
          <img src={require("../images/about1.jpg")} alt="Collab 1" className="collab-img" />
          <img src={require("../images/about2.jpg")} alt="Collab 2" className="collab-img" />
          <img src={require("../images/about3.jpg")} alt="Collab 3" className="collab-img" />
          <img src={require("../images/about4.jpg")} alt="Collab 4" className="collab-img" />
        </div>
      </div>

      {/* Our Honours Section */}
      <div className="honours-section">
        <h3>Our Honours</h3>
        <div className="honours-grid">
          <img src={require("../images/Honour1.jpg")} alt="Honour 1" className="honour-img" />
          <img src={require("../images/Honour2.jpg")} alt="Honour 2" className="honour-img" />
          <img src={require("../images/Honour3.jpg")} alt="Honour 3" className="honour-img" />
          <img src={require("../images/Honour4.jpg")} alt="Honour 4" className="honour-img" />
        </div>
      </div>
    </div>
  );
};

export default About;